/**
 * Recently Viewed Products Tracker
 * Add this script to your product.liquid template or theme.liquid
 * It tracks product views and stores them in localStorage
 */

(function() {
  'use strict';

  // Configuration
  const MAX_PRODUCTS = 10; // Maximum number of products to store
  const STORAGE_KEY = 'recentlyViewed';

  /**
   * Track the current product view
   */
  function trackProductView() {
    // Check if we're on a product page
    if (!window.ShopifyAnalytics || !window.ShopifyAnalytics.meta || !window.ShopifyAnalytics.meta.product) {
      return;
    }

    const product = window.ShopifyAnalytics.meta.product;
    const productHandle = product.handle || product.id;

    if (!productHandle) {
      return;
    }

    try {
      // Get existing recently viewed products
      let recentlyViewed = [];
      const stored = localStorage.getItem(STORAGE_KEY);
      
      if (stored) {
        recentlyViewed = JSON.parse(stored);
      }

      // Remove the current product if it's already in the list
      recentlyViewed = recentlyViewed.filter(handle => handle !== productHandle);

      // Add current product to the beginning
      recentlyViewed.unshift(productHandle);

      // Limit to MAX_PRODUCTS
      if (recentlyViewed.length > MAX_PRODUCTS) {
        recentlyViewed = recentlyViewed.slice(0, MAX_PRODUCTS);
      }

      // Save back to localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentlyViewed));

      // Dispatch custom event for other scripts to listen to
      document.dispatchEvent(new CustomEvent('product:viewed', {
        detail: {
          handle: productHandle,
          recentlyViewed: recentlyViewed
        }
      }));

    } catch (error) {
      console.error('Error tracking product view:', error);
    }
  }

  /**
   * Get recently viewed products
   * @returns {Array} Array of product handles
   */
  function getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error getting recently viewed products:', error);
      return [];
    }
  }

  /**
   * Clear recently viewed products
   */
  function clearRecentlyViewed() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      document.dispatchEvent(new CustomEvent('product:cleared'));
    } catch (error) {
      console.error('Error clearing recently viewed products:', error);
    }
  }

  // Track product view on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackProductView);
  } else {
    trackProductView();
  }

  // Make functions available globally
  window.RecentlyViewed = {
    track: trackProductView,
    get: getRecentlyViewed,
    clear: clearRecentlyViewed
  };

})();
